const styles = theme => ({
  root: {
    marginTop: 24,
    marginBottom: 24,
    textAlign: 'center',
    alignItems: 'center',
  },
  leftButton: {
    zIndex: 9000,
    position:'absolute',
    marginLeft: -150,
    marginTop: 338,
    [theme.breakpoints.up('sm')]: {
      marginLeft: -170,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: -170,
    },
  },
  rightButton: {
    zIndex: 9000,
    position: 'absolute',
    marginLeft: 100,
    marginTop: 335,
    [theme.breakpoints.up('sm')]: {
      marginLeft: 120,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 120,
    },
  },
  icon: {
    width:40,
    height:40,
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Candidate/components/User/scenes/Core/components/PrevNextButtons/styles.js